export default function ScoreReport(props) {
  const { data } = props;
  return <h1>Score {data.id}</h1>;
}
